import { Routes } from '@angular/router';
import { HomeComponent } from './features/home/home.component';
import { RequirementComponent } from './features/requirement/requirement.component';
import { AfastamentoComponent } from './features/afastamento/afastamento.component';
import { DadosPessoaisComponent } from './features/dados-pessoais/dados-pessoais.component';
import { DadosFuncionaisComponent } from './features/dados-funcionais/dados-funcionais.component';
import { AlteracoesFuncionaisComponent } from './features/alteracoes-funcionais/alteracoes-funcionais.component';
import { DeducoesComponent } from './features/deducoes/deducoes.component';
import { AcrescimosComponent } from './features/acrescimos/acrescimos.component';
import { RegrasComponent } from './features/regras/regras.component';
import { ComposicaoAtoComponent } from './features/composicao-ato/composicao-ato.component';
import { AnexarDocumentosComponent } from './features/anexar-documentos/anexar-documentos.component';
import { RequerimentoDownloadComponent } from './features/requerimento-download/requerimento-download.component';
import { AbrirProcessoComponent } from './features/abrir-processo/abrir-processo.component';
import { PesquisarProcessoComponent } from './features/pesquisar-processo/pesquisar-processo.component';
import { ProcessoDetalheComponent } from './features/processo-detalhe/processo-detalhe.component';

export const routes: Routes = [
  {
    path: 'pesquisar-militar',
    component: HomeComponent // ou loadComponent se for lazy
  },
  {
    path: 'requirement',
    component: RequirementComponent // ou loadComponent se for lazy
  },
  {
    path: 'afastamento',
    component: AfastamentoComponent // ou loadComponent se for lazy
  },
  {
    path: 'dados-pessoais',
    component: DadosPessoaisComponent // ou loadComponent se for lazy
  },
  {
    path: 'dados-funcionais',
    component: DadosFuncionaisComponent
  },
  {
    path: 'alteracoes-funcionais',
    component: AlteracoesFuncionaisComponent
  },
  {
    path: 'deducoes',
    component: DeducoesComponent
  },
  {
    path: 'acrescimos',
    component: AcrescimosComponent
  },
  {
    path: 'regras',
    component: RegrasComponent
  },
  {
    path: 'composicao-ato',
    component: ComposicaoAtoComponent
  },
  {
    path: 'anexar-documentos',
    component: AnexarDocumentosComponent
  },
  {
    path: 'requerimento-download',
    component: RequerimentoDownloadComponent
  },
  {
    path: 'abrir-processo',
    component: AbrirProcessoComponent
  },
  {
    path: 'pesquisar-processo',
    component: PesquisarProcessoComponent
  },
  {
    path: 'processo/:id',
    component: ProcessoDetalheComponent
  }
];
